import { render, staticRenderFns } from "./addCreateCode.vue?vue&type=template&id=5d12829c&scoped=true&"
import script from "./addCreateCode.vue?vue&type=script&lang=js&"
export * from "./addCreateCode.vue?vue&type=script&lang=js&"
import style0 from "./addCreateCode.vue?vue&type=style&index=0&id=5d12829c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12829c",
  null
  
)

export default component.exports